import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    large: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    marginBottom: {
      type: Boolean,
      default: false,
    },
  },
})
export default class SpinnerLoadingComponent extends Vue {
}
